import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { fetchMe, login as apiLogin, setToken, clearToken, getToken } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        if (!getToken()) {
            setUser(null);
            setLoading(false);
            return;
        }
        try {
            const u = await fetchMe();
            setUser(u);
        } catch {
            clearToken();
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const signIn = async (email, password) => {
        const res = await apiLogin(email, password);
        setToken(res.access_token);
        setUser(res.user);
        return res.user;
    };

    const signOut = () => {
        clearToken();
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, loading, signIn, signOut, refresh }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
